<template>
  <label for="branch-categories-multiselect-component" class="form-label">
    {{ $t('branch.category.title') }}
  </label>
  <TomSelect
    v-model="componentValue.selectedCategories"
    :options="{
      create: false,
      placeholder: $t('branch.category.select')
    }"
    class="w-full"
    multiple
  >
    <option v-for="category in branchCategories" :value="category.uuid" :key="category.uuid">
      {{ category.title }}
    </option>
  </TomSelect>
</template>

<script>
import { defineComponent, computed } from 'vue'
import branchApi from '../../services/branch-categories/branch-category.api'

export default defineComponent({
  data() {
    return {
      branchCategories: []
    }
  },
  mounted() {
    branchApi.getList().then(
      (response) => {
        this.branchCategories = response.data.data
      },
      (error) => {
        alert(error)
      }
    )
  },
  props: {
    selectedCategories: {
      type: Object,
      default: () => {}
    }
  },

  emits: ['update:selectedCategories'],

  setup(props, { emit }) {
    const componentValue = computed({
      get: () => props.selectedCategories,
      set: (value) => emit('update:selectedCategories', value)
    })

    return {
      componentValue
    }
  }
})
</script>
